const kformBuilderOptionOptionsLabelPositionController = /* @ngInject */ (/** @type {any} */ $scope) => {
	$scope.optionsLabelPositions = [
		{
			value: 'top',
			title: 'Top',
		},
		{
			value: 'left',
			title: 'Left',
		},
		{
			value: 'right',
			title: 'Right',
		},
		{
			value: 'bottom',
			title: 'Bottom',
		},
	];

	if (!$scope.component.optionsLabelPosition) {
		$scope.component.optionsLabelPosition = 'right';
	}
};

export default kformBuilderOptionOptionsLabelPositionController;
